// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPurseAccessDto } from './IPurseAccessDto';
import {
    IPurseAccessDtoFromJSON,
    IPurseAccessDtoFromJSONTyped,
    IPurseAccessDtoToJSON,
    IPurseAccessDtoToJSONTyped,
} from './IPurseAccessDto';

/**
 * 
 * @export
 * @interface ICardPurseAccessUpdateDto
 */
export interface ICardPurseAccessUpdateDto {
    /**
     * 
     * @type {Array<IPurseAccessDto>}
     * @memberof ICardPurseAccessUpdateDto
     */
    purses: Array<IPurseAccessDto>;
}

/**
 * Check if a given object implements the ICardPurseAccessUpdateDto interface.
 */
export function instanceOfICardPurseAccessUpdateDto(value: object): value is ICardPurseAccessUpdateDto {
    if (!('purses' in value) || value['purses'] === undefined) return false;
    return true;
}

export function ICardPurseAccessUpdateDtoFromJSON(json: any): ICardPurseAccessUpdateDto {
    return ICardPurseAccessUpdateDtoFromJSONTyped(json, false);
}

export function ICardPurseAccessUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardPurseAccessUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'purses': ((json['purses'] as Array<any>).map(IPurseAccessDtoFromJSON)),
    };
}

export function ICardPurseAccessUpdateDtoToJSON(json: any): ICardPurseAccessUpdateDto {
    return ICardPurseAccessUpdateDtoToJSONTyped(json, false);
}

export function ICardPurseAccessUpdateDtoToJSONTyped(value?: ICardPurseAccessUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purses': ((value['purses'] as Array<any>).map(IPurseAccessDtoToJSON)),
    };
}

